import { BriefcaseSolid, UserSolid } from '@allocab/allocab-icons';
import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { getPanelNameDescriptionByKey, getPanelNameLabelByKey } from '@allocab/allocab-shared-utils';

import { PanelImage } from './PanelImage';
import { formatPrice } from '../../utils/trip';

interface Props {
  trip: TripOutput;
}

export const PanelDetail = ({ trip }: Props) => {
  return (
    <div className="flex items-center w-full min-h-200 shadow-md shadow-shadow p-2">
      <div className="flex items-center w-full">
        <PanelImage panelVars={trip.panelVars} />
        <div className="flex flex-col">
          <span className="mx-2">{getPanelNameLabelByKey(trip.panelVars.key)} </span>
          <small className="mx-2">{getPanelNameDescriptionByKey(trip.panelVars.key)}</small>
        </div>
      </div>
      <div className="flex items-center">
        <div className="flex flex-col">
          {trip.tripVars.displayPrice ? (
            <div className="flex justify-end mb-1">
              <strong>{formatPrice(trip.resume.price.amountWithTax, trip.resume.price.currency, 0, 2)}</strong>
            </div>
          ) : null}
          <div className="flex">
            <div className="rounded-full border flex items-center justify-center mr-1 px-1">
              <UserSolid width={12} height={12} />
              <small className="ml-1">{trip.panelVars?.nbPassengers}</small>
            </div>
            <div className="rounded-full border flex items-center justify-center px-1">
              <BriefcaseSolid width={12} height={12} />
              <small className="ml-1">{trip.panelVars?.nbBagages}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
